import { Stack, Typography } from "@mui/material"
import type { Occurrence } from "../../interface/occurrences"
import { RecordedValue } from "./recordedValue"

export function OccurrenceEffects({
  pin,
  deletePrevious,
}: Pick<Occurrence, "pin" | "deletePrevious">) {
  return (
    <Stack spacing={1}>
      <Typography>
        Результаты действий независимы от доставки. Ошибка закрепления или
        удаления не отменяет confirmed.
      </Typography>
      <section aria-label="Закрепление">
        <Typography variant="h6">Закрепление</Typography>
        <RecordedValue value={pin} />
      </section>
      <section aria-label="Удаление предыдущих сообщений">
        <Typography variant="h6">Удаление предыдущих сообщений</Typography>
        <RecordedValue value={deletePrevious} />
      </section>
    </Stack>
  )
}
